<template>
	<g fill="#555" font-family="Helvetica" font-size="16" :transform="`translate(0 ${y})`">
		<rect width="1051" :height="height" fill="#FBFBFB" fill-rule="nonzero" rx="16"></rect>
		<text fill="#555" fill-rule="nonzero" font-size="22">
			<tspan x="30" y="47">{{ title }}</tspan>
		</text>
		<slot />
	</g>
</template>

<script>
	export default {
		name: 'CategoryBlock',
		props: {
			y: {
				type: Number,
				required: true,
			},
			height: {
				type: Number,
				required: true,
			},
			title: {
				type: String,
				required: true
			},
		},
	}
</script>